import * as actionTypes from 'actions';

const initialState = {
    orders: [],
    pageNumber: 1
};

const orderReducer = (state = initialState, action) => {


    switch (action.type) {
        /** GET ORDERS */
        case actionTypes.GET_ORDERS: {
            return {
                ...state,
                orders: action.payload,
            };
        }
        /** DEFAULT STATE */
        default: {
            return state;
        }
    }
};

export default orderReducer;